export enum DeliverableTemplateType {
  WhiteText = 'white-text',
  BlackText = 'black-text',
}
